import { IResetService } from "@/services/IResetService";
import { ResetService } from "@/services/ResetService";
import { Container } from "inversify";
import { IoCTypes } from "./IoCTypes";

export function bindResetService(container:Container) {
    container.bind<IResetService>(IoCTypes.ResetService).to(ResetService)
}